<div>
  <div class="ficha-veiculo-lista" [ngClass]="{'ficha-veiculo-lista_last': i === (veiculos.length -2) }"
    *ngFor="let veiculo of veiculos; let i = index">

    <ng-container *ngIf="fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === fichaCadastro._tipo && veiculos.length === 1;">
      <app-ficha-cadastro-veiculo-info [veiculo]="veiculo" [isPesados]="isPesados" [veiculos]="veiculos"
        [isInformarManualmente]="isInformarManualmente" (salvar)="saveVeiculo($event, i)" (adicionar)="addVeiculo()"
        (changeForm)="changeForm.emit($event)" (changeFormValid)="changeFormValid.emit($event)"
        (remover)="cancelVeiculo(i)" [fichaCadastro]="fichaCadastro">
      </app-ficha-cadastro-veiculo-info>
    </ng-container>

    <ng-container *ngIf="fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND === fichaCadastro._tipo && veiculos.length > 1;">
      <app-ficha-cadastro-veiculo-info *ngIf="veiculo.isEdit" [veiculo]="veiculo" [isPesados]="isPesados"
        [veiculos]="veiculos" [isInformarManualmente]="isInformarManualmente" (salvar)="saveVeiculo($event, i)"
        (adicionar)="addVeiculo()" (changeForm)="changeForm.emit($event)"
        (changeFormValid)="changeFormValid.emit($event)" (remover)="cancelVeiculo(i)"
        [fichaCadastro]="fichaCadastro">
      </app-ficha-cadastro-veiculo-info>

      <app-ficha-cadastro-veiculo-card *ngIf="veiculo.saved && !veiculo.isEdit" [hasIdSimulacao]="hasIdSimulacao"
        [index]="i" (remover)="removeVeiculo(i)" (editar)="editarVeiculo($event, i)" [veiculos]="veiculos"
        [veiculo]="veiculo" [fichaCadastro]="fichaCadastro">
      </app-ficha-cadastro-veiculo-card>
    </ng-container>

    <ng-container *ngIf="fichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND !== fichaCadastro._tipo">
      <app-ficha-cadastro-veiculo-info *ngIf="!veiculo.saved || veiculo.isEdit" [veiculo]="veiculo"
        [isPesados]="isPesados" [veiculos]="veiculos" [isInformarManualmente]="isInformarManualmente"
        (salvar)="saveVeiculo($event, i)" (adicionar)="addVeiculo()" (changeForm)="changeForm.emit($event)"
        (changeFormValid)="changeFormValid.emit($event)" (remover)="cancelVeiculo(i)" [fichaCadastro]="fichaCadastro">
      </app-ficha-cadastro-veiculo-info>

      <app-ficha-cadastro-veiculo-card *ngIf="veiculo.saved && !veiculo.isEdit" [hasIdSimulacao]="hasIdSimulacao"
        [index]="i" (remover)="removeVeiculo(i)" (editar)="editarVeiculo($event, i)" [veiculos]="veiculos"
        [veiculo]="veiculo">
      </app-ficha-cadastro-veiculo-card>
    </ng-container>
  </div>

  <div *ngIf="isPesados && showAddVeiculo" class="row marginT30 form-group tab-buttons ficha-veiculo-lista_btn">
    <a (click)="addVeiculo()" class="bt-back btn btn-border-orange pull-left">
      <i class="fa fa-plus mrBt"></i> Adicionar Veículo</a>
  </div>
</div>
